import React, {useState } from 'react';
import "./BidderForm.css";
import Forward from '../assets/icons/forward.svg'
import {motion} from "motion/react"



const BidderForm = ({ onNewBid, highestBid, isAuctionActive, name, bidIncrement, setShowError}) => {
  const [bidAmount, setBidAmount] = useState('');
  const [err, displayErr] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const bidHistory = document.getElementById('bid-history-box-id');

  const handleChange = (e) => {
    const value = e.target.value;

    // Only allow digits (empty string is allowed so user can delete)
    if (/^\d*$/.test(value)) {
      setBidAmount(value);
    }
  };


  const handleSubmit = (e) => {

    e.preventDefault();

    const parsedBidAmount = parseFloat(bidAmount); // Convert bid amount to a number
    

    // Check if the bid is higher than the current highest bid
    if (parsedBidAmount <= highestBid && displayErr && isAuctionActive) {

      setErrorMessage("Your bid must be higher than the current highest bid.");
      setShowError(true);
      return;
    }


    // Prevent submission of duplicate bids (optional: based on name or amount)
    if (parsedBidAmount === highestBid && displayErr && isAuctionActive)  {

      setErrorMessage("Please bid higher than the current bid.");
      setShowError(true);

      return;
    }

    if (isNaN(parsedBidAmount) && displayErr && isAuctionActive) {

      setErrorMessage("Please enter a number.");
      setShowError(true);

      return;
    }
    

    if (!(parsedBidAmount % bidIncrement === 0 && isAuctionActive))  {

      setErrorMessage(`Please place your bid in increments of ${bidIncrement}`);
      setShowError(true);


      return;
    }

    setErrorMessage('')


    // Submit the new bid
    onNewBid({ name, amount: parsedBidAmount });

    // Clear the form after successful submission
    setBidAmount('');
    displayErr(false)
    setShowError(false);

  };

  const resetErrorMessage = () => {
    setErrorMessage (' ');
    bidHistory.scrollTo({top: 0, behavior: 'smooth'})
  };

  if (!bidIncrement) {

  return (
    <div className = "input-container">

    <form onSubmit={handleSubmit} className="bidder-form">
      <input
        id = 'bid-input'
        type="input"
        placeholder="Enter a bid"
        value={bidAmount}
        onChange={handleChange}
        required
        className={`bid-input ${errorMessage ? 'error' : ''}`}
        disabled={!isAuctionActive} // Disable form when auction ends
      />



      <button type="submit" disabled={!isAuctionActive} onClick={resetErrorMessage}><img src = {Forward} className =  "bid-forward-button"></img></button>


      

      {errorMessage && <motion.p 
         initial = {{y: 10, opacity: 0}}
         animate = {{y: 0, opacity: 1}}
         transition = {{duration: 0.2, ease: "easeOut"}} className="error-message">{errorMessage}</motion.p>}



    </form>
    </div>

  );

} else {

  return (
    <div className = "input-container">

    <form onSubmit={handleSubmit} className="bidder-form">
      <input
        type="input"
        placeholder="Enter a bid"
        value={bidAmount}
        onChange={(e) => setBidAmount(e.target.value)}
        required
        className={`bid-input ${errorMessage ? 'error' : ''}`}
        disabled={!isAuctionActive} // Disable form when auction ends
      />



      {/* <button type="submit" disabled={!isAuctionActive} onClick={resetErrorMessage}><img src = {Forward} className =  "bid-forward-button"></img></button> */}

      <button type="submit" disabled={!isAuctionActive} onClick={resetErrorMessage}>
        <div className = "formSubmitButtonWrapper" >

            <div className  = "formSubmitButton">
            
              <span className='s1'> </span>
              <span className='s2'> </span>
            </div>

        </div>
      
      </button>



      <p className="bid-increment">Bid Increment: +{bidIncrement}</p>

      {errorMessage && <motion.p 
         initial = {{y: 10, opacity: 0}}
         animate = {{y: 0, opacity: 1}}
         transition = {{duration: 0.2, ease: "easeOut"}} className="error-message">{errorMessage}</motion.p>}



    </form>
    </div>

  );


}
};

export default BidderForm;
